
@if (!showSwiper()){
  @if(!isBottomSheet()){
    <div class="swiper-details__skeleton" [ngClass]="{'modalSize': isBottomSheet()}">
        @for (multimedia of items(); track multimedia) {
            <div class="swiper-details__skeleton__item"></div>
        }
    </div>
  } @else if (multimedia()?.length > 0) { 
    <!--TODO: QUITO EL SKELETON EN CASO DE QUE NO HAY MULTIMEDIA DE MOMENTO EN 
    PLANIFICADOR NO HAY FORMA DE ACCEDER A LA IMAGEN POR DEFECTO 
    (HABRÍA QUE ESPERAR A LOS NUEVOS ENDPOINTS)-->
    <div class="swiper-details__skeleton" [ngClass]="{'modalSize': isBottomSheet()}">
        <div class="swiper-details__skeleton__item"></div>
    </div>
  }
}

@if(!isBottomSheet()){
  <swiper class="swiper-details"
      [class.dnone]="!showSwiper()" 
      [class.dblock]="showSwiper()"
      [slidesPerView]="1" 
      [loop]="true" 
      [freeMode]="true" 
      [pagination]="{ clickable: true }"
      [breakpoints]="{ 
          '500': {
              slidesPerView: 2 <= items()?.length ? 2 : 1,
              spaceBetween: 10,
          },
          '1000': {
              slidesPerView: 3 <= items()?.length ? 3 : 2,
              spaceBetween: 10,
          },
          '1500': {
              slidesPerView: 4 <= items()?.length ? 4 : 3,
              spaceBetween: 10,
          }
      }">
          @for(media of multimedia(); track media.name; let i = $index) {
              <ng-template swiperSlide>
                  @if(media.type === 'video'){
                      <video 
                        [src]="media.name" 
                        [ngClass]="{'modalSize': isBottomSheet()}" 
                        controls
                      ></video>
                  }
                  @if(media.type === 'image'){
                    <img 
                      draggable="false" 
                      [src]="media.name" 
                      (error)="tools.onImageError($event, getDefaultImgFileName(i))" 
                      (click)="openModal(media.imageIndex, galleryImages, media.imageIndex)" 
                      [ngClass]="{'modalSize': isBottomSheet()}"
                    >
                  }
              </ng-template>
          }
  </swiper>
}
@else {
      <swiper class="swiper-details"
          [class.dnone]="!showSwiper()" 
          [class.dblock]="showSwiper()"
          [slidesPerView]="1" 
          [loop]="true" 
          [freeMode]="true" 
          [pagination]="{ clickable: true }"
      >
          @for(media of multimedia(); track media.name; let i = $index) {
              <ng-template swiperSlide>
                  @if(media.type === 'video'){
                      <video 
                        [src]="media.name" 
                        [ngClass]="{'modalSize': isBottomSheet()}" 
                        controls
                      ></video>
                  }
                  @if(media.type === 'image'){
                      <img 
                        draggable="false" 
                        [src]="media.name" 
                        (error)="tools.onImageError($event, getDefaultImgFileName(i))" 
                        (click)="openModal(media.imageIndex, galleryImages, media.imageIndex)" 
                        [ngClass]="{'modalSize': isBottomSheet()}"
                      >
                  }
              </ng-template>
          }
  </swiper>
}
